import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { AccordionProfessionTitle } from 'shell/view-models/accordion-profession-title';
import ProfessionTitleForm from 'shell/components/shared/profession-title-form';
import { NewPersonVM } from 'shell/components/shared/sipo-person-form/new-person';

interface ProfessionTitleProps {
  disabled?: boolean;
}

const ProfessionTitleComponent = ({
  disabled = false,
}: ProfessionTitleProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<NewPersonVM>();

  const onFieldProfessionTitleChange = useEventCallback(
    (
      key: keyof AccordionProfessionTitle,
      value: AccordionProfessionTitle[keyof AccordionProfessionTitle]
    ) => {
      formContext.setFieldValue('professionTitle', {
        ...formContext.values.professionTitle,
        [key]: value,
      });
    }
  );

  const onFieldsProfessionTitleChange = useCallback(
    (values) => {
      formContext.setFieldValue('professionTitle', {
        ...formContext.values.professionTitle,
        ...values,
      });
    },
    [formContext.values.professionTitle, formContext.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-profession-title-content"
        id="panel-person-profession-title-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Professione/Titolo di studio</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ProfessionTitleForm
          values={formContext.values.professionTitle}
          onChange={onFieldProfessionTitleChange}
          onChangeValues={onFieldsProfessionTitleChange}
          errors={formContext.errors?.professionTitle as FormikErrors<AccordionProfessionTitle>}
          touched={formContext.touched?.professionTitle as FormikTouched<AccordionProfessionTitle>}
          disabled={disabled}
        />
      </AccordionDetails>
    </Accordion>
  );
};

ProfessionTitleComponent.displayName = 'Accordion Profession or Title component';

const ProfessionTitle = memo(ProfessionTitleComponent);

export default ProfessionTitle;
